import React from 'react'
import AssetMap from './Map'

/**
 * Will hold additional panels, but currently only holds map.
 * @returns
 */
export const MapContainer = () => {
  return (
      <AssetMap  />
  )
}
